import type { ApiErrorBody, ApiErrorCode } from "./types";

/** Typed error carrying the backend's stable error code and any extra fields. */
export class ApiError extends Error {
  readonly code: ApiErrorCode;
  readonly status: number;
  readonly body: ApiErrorBody;

  constructor(status: number, body: ApiErrorBody) {
    super(`API error ${status}: ${body.error}`);
    this.name = "ApiError";
    this.status = status;
    this.code = body.error;
    this.body = body;
  }
}
